module.exports = __webpack_public_path__ + "0427ab32ab4da6d660cffb311ed212c3.svg";